<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1">
<p class="calibre2"> <span class="calibre3"> </span> </p>
<p class="calibre2"> <span class="calibre3"> </span> </p>
<p class="calibre2"> <span class="calibre3"> </span> </p>
<p class="calibre2"> <span class="calibre3"> </span> </p>
<p class="calibre2"> <span class="calibre3"> </span> </p>
<p class="calibre2"> <span class="calibre3"> </span> </p>
<p class="calibre2"> <span class="calibre3"> </span> </p>
<p class="calibre2"> <span class="calibre3"> </span> </p>
<p class="calibre2"> <span class="calibre3"> </span> </p>
<p class="calibre4"> <a class="calibre5" id="_Toc29478516"><span class="calibre6">Jewel of the Kingdom</span></a> </p>
<p class="calibre7"> <span class="calibre3"> </span> </p>
<p class="calibre8"> <span class="calibre3">By</span> </p>
<p class="calibre8"> <span class="calibre3">Roy Dimond and Lorraine Dimond</span> </p>
<p class="calibre2"> <span class="calibre9" id="calibre_pb_0"></span>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0000_split_000.vue?15119621